import { Sidebar } from "flowbite-react";
import { HiChartPie, HiUser, HiViewBoards } from "react-icons/hi";
import { baseUrl } from '../config';



export function Options() {
  return (
    <Sidebar aria-label="Default sidebar example" className="w-25 h-full">
      <Sidebar.Items>
        <Sidebar.ItemGroup>
          <Sidebar.Item href="/post-schedule" icon={HiChartPie}>
            Schedule
          </Sidebar.Item>
          <Sidebar.Item href="/advertisement-promotions" icon={HiViewBoards} >
            Advertising
          </Sidebar.Item>
          <Sidebar.Item href="#" icon={HiUser}>
            Social handlings
          </Sidebar.Item>
        </Sidebar.ItemGroup>
      </Sidebar.Items>
    </Sidebar>
  );
}
